const sideAnchorsContainer = document.querySelector('.side-anchors__container');
const sideAnchorsList = document.querySelector('.side-anchors__list');

// svg attributes
const SVG_FILL = 'none';
const XMLNS = 'http://www.w3.org/2000/svg';
const VIEWBOX = '0 0 13 10';

// path attributes
const PATH_D = 'M6.5 0l5.63 9.75H.87L6.5 0z';
const PATH_FILL = '#E5E5E5';

let observerOptions = {
    rootMargin: '0px',
    threshold: 0.6
};
if (sideAnchorsContainer) {
    // used in the intersection observer to toggle active state on triangles
    const toggleTriangle = (e) => {
        const sectionVisible = e[0].isIntersecting;
        const triangle = listItemsArr.find(
            (item) => item.getAttribute('data-nav-item') === e[0].target.id
        );
        const triangleActive = triangle.classList.contains('side-anchors__item--active');
        if (!triangleActive && sectionVisible) {
            listItemsArr.forEach((item) =>
                item.classList.remove('side-anchors__item--active')
            );
            triangle.classList.add('side-anchors__item--active');
        }
    };

    // programatically determine how many immediate <section> children of
    // .barba-container there are, create corresponding anchor elements
    // with triangle SVGs
    const sections = document.querySelectorAll('.barba-container > section');
    const sectionsArr = Array.from(sections);
    const listItemsArr = [];
    sectionsArr.map((item) => {
        // create all the DOM elements
        const anchor = document.createElement('a');
        anchor.href = `#${item.id}`;
        const listItem = document.createElement('li');
        listItem.classList.add('side-anchors__item');
        listItem.setAttribute('data-nav-item', item.id);
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('fill', SVG_FILL);
        svg.setAttribute('xmlns', XMLNS);
        svg.setAttribute('viewBox', VIEWBOX);
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', PATH_D);
        path.setAttribute('fill', PATH_FILL);

        // nest the DOM elements, add them to the existing sideAnchorsList
        svg.appendChild(path);
        listItem.appendChild(svg);
        anchor.appendChild(listItem);
        sideAnchorsList.appendChild(anchor);

        // add the list itme to our listItemsArr
        listItemsArr.push(listItem);

        // add intersection observer to element
        let observer = new IntersectionObserver(toggleTriangle, observerOptions);
        observer.observe(document.querySelector(`#${item.id}`));
    });

    // used to determine whether the side anchors are positoned absolutely (when scrolled near the
    // top) of fixed (the rest of the page)
    const toggleSideAnchorsPosition = () => {
        const userYPos = window.scrollY;
        const isFixed = sideAnchorsContainer.classList.contains(
            'side-anchors__container--fixed'
        );
        const secondSectionTop = userYPos + sectionsArr[1].getBoundingClientRect().top;
        const secondSectionHeight = sectionsArr[1].offsetHeight;
        const windowHeight = window.innerHeight;
        const yBreakpoint = secondSectionTop - windowHeight / 2 + secondSectionHeight / 2;

        const makeAbsolute = () => {
            sideAnchorsContainer.classList.remove('side-anchors__container--fixed');
            sideAnchorsContainer.style.top = `${secondSectionTop}px`;
            sideAnchorsContainer.style.height = `${secondSectionHeight}px`;
        };

        const makeFixed = () => {
            sideAnchorsContainer.classList.add('side-anchors__container--fixed');
            sideAnchorsContainer.style.top = `0`;
            sideAnchorsContainer.style.height = '100vh';
        };

        // only triggered on initial page load
        if (sideAnchorsContainer.offsetLeft < 0) {
            sideAnchorsContainer.style.left = 0;
            if (userYPos < yBreakpoint) {
                setTimeout(makeAbsolute(), 500);
            } else {
                makeFixed();
            }
        }

        // triggered as user scrolls
        if (userYPos > yBreakpoint && !isFixed) {
            makeFixed();
        } else if (userYPos < yBreakpoint && isFixed) {
            makeAbsolute();
        }
    };

    addEventListener('scroll', toggleSideAnchorsPosition);
    toggleSideAnchorsPosition();
}
